export type InquirySelectValue =
  | string
  | {
      label: string;
      value: string;
    };

export function selectedInquiryValue(
  field: InquirySelectValue | null | undefined,
): string {
  if (!field) return '';
  return typeof field === 'string' ? field : field.value;
}
